module.exports = __webpack_public_path__ + "img/thumb-zeiss-full-exposure@2x.8791dc2c.png";